import { isBefore } from 'date-fns';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { isErrorMarkedAsHandled, markErrorAsHandled } from '@confluence/graphql';
import { useGetOnboardingState } from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState';
import { GROWTH_LUNA_EXPERIMENT } from '@confluence/onboarding-helpers/entry-points/constants/growth-constants';

export const useIsPremiumDirectBuyStandardExperimentExposed = (skip: boolean) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { data, error, loading } = useGetOnboardingState(
		GROWTH_LUNA_EXPERIMENT.RECOMMEND_STANDARD_BUY_PREMIUM_EOT_MODAL_SEEN,
		skip,
	);

	if (error && !isErrorMarkedAsHandled(error)) {
		createAnalyticsEvent({
			type: 'sendOperationalEvent',
			data: {
				action: 'failed',
				actionSubject: 'useIsPremiumDirectBuyStandardExperimentExposed',
				source: 'RecommendStandardOverPremiumModal',
				attributes: {
					growthFeature: 'RecommendStandardOverPremiumModal',
					error: error.message,
				},
			},
		}).fire();
		markErrorAsHandled(error);
	}

	const exposedDate = data?.onboardingState?.[0]?.value;
	const today = new Date();

	return {
		isExposed:
			(!!exposedDate &&
				isBefore(Date.parse(today.toISOString()), Date.parse(exposedDate)) &&
				!skip) ||
			(loading && !skip),
	};
};
